module.exports = __webpack_public_path__ + "assets/img/dragon-attack.850d886e.png";